import type { APIGetSlipsResponse } from '../interfaces/propsService/api';
import type { GetSlipsResponse } from '../interfaces/propsService/parsed/slips';

import { parseSlip } from './parseSlip';

export const parseSlips = (response: APIGetSlipsResponse): GetSlipsResponse => ({
  ...response,
  data: response.data.map(parseSlip),
});
